import React from "react"
import { Carousel } from "@components/common/carousel/Carousel"

import * as s from "./PageCarousel.module.scss"

export const PageCarousel = ({ data }) => {
  if (!data.slides) {
    return <></>
  }
  let slides = data.slides.map(slide => {
    return {
      ...slide,
      image: slide.image ? slide.image.sourceUrl : null,
    }
  })
  return (
    <div className={s.PageCarousel}>
      <Carousel
        data={{
          slides: slides,
        }}
      />
    </div>
  )
}
